<template>
  <div id="index">
    <mobile></mobile>
  </div>
</template>

<script>
    import img1 from '@/assets/images/index/main-slider-1-1.jpg';
    import img2 from '@/assets/images/index/main-slider-1-2.jpg';
    import img3 from '@/assets/images/index/liucheng-dark.png';
    import img4 from '@/assets/images/index/liucheng.png';
    import img5 from '@/assets/images/index/feiyong.png';
    import img6 from '@/assets/images/index/feiyong-dark.png';
    import desk from './components/desk'
    import mobile from './components/mobile'
    export default {
        name: "index",
        data(){
          return {
            // appName:this.$AppName,
            // images:[img1,img2],
            // langs:this.$Language,
            // value2:115,
            // value1:this.$Language=='VN'?2000000:3000,
            // day:this.$day,
            // coin:this.$coin,
            // show:false
          }
        },
      components:{
        desk,
        mobile
      },
        // computed:{
        //   min(){
        //     if(this.langs=='VN'){
        //       return '1500000'
        //     }else{
        //       return '1500';
        //     }
        //   },
        //   max(){
        //     if(this.langs=='VN'){
        //       return '5000000'
        //     }else{
        //       return '5000';
        //     }
        //   },
        //   step(){
        //     return this.langs=='VN'?500000:500;
        //   },
        //   getTime(){
        //     let time;
        //     let date = new Date();
        //     let year = date.getFullYear();
        //     let month =date.getMonth()+1;
        //     let day = date.getDate();
        //     //date对象的set方法，自动折算
        //     date.setDate(Number(this.value2)+day);
        //     year = date.getFullYear();
        //     month =Number(date.getMonth()+1)<10?'0'+(date.getMonth()+1):date.getMonth()+1;
        //     day = Number(date.getDate())<10?'0'+date.getDate():date.getDate();
        //     time=day+"-"+month+"-"+year;
        //     return time;
        //   }
        // },
        // methods:{
        //   add_comma_toThousands(num) {
        //     var num = (num || 0).toString();
        //     var result = '';
        //     while (num.length > 3) {
        //       result = '.' + num.slice(-3) + result;
        //       num = num.slice(0, num.length - 3);
        //     }
        //     if (num) { result = num + result; }
        //     return result;
        //   },
        //   login(){
        //     var system = {
        //       win: false,
        //       mac: false,
        //       xll: false
        //     };
        //     //检测平台
        //     var p = navigator.platform;
        //     system.win = p.indexOf("Win") == 0;
        //     system.mac = p.indexOf("Mac") == 0;
        //     system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
        //     if (system.win || system.mac || system.xll) {
        //       // this.$notify({
        //       //   type: 'danger',
        //       //   message: this.$t('message.use_phone')
        //       // });
        //       this.$dialog.alert({
        //         title: '提示',
        //         message: this.$t('message.use_phone'),
        //       });
        //     } else {
        //       this.$router.push('/auth/register')
        //     }
        //   },
        //   changeIMG(a){
        //     if(a=='IMG1'){
        //       this.$refs.IMG1.setAttribute("src",img3);
        //     }else{
        //       this.$refs.IMG2.setAttribute("src",img6);
        //     }
        //
        //   },
        //   changeIMGLeave(a){
        //     if(a=='IMG1') {
        //       this.$refs.IMG1.setAttribute("src", img4);
        //     }else{
        //       this.$refs.IMG2.setAttribute("src", img5);
        //     }
        //   },
        //   showPopup() {
        //     this.show = true;
        //   },
        // }
    }
</script>

<style scoped lang="scss">
  @media (min-width:1430px) {
    #desk{
      display: block;
    }
    #Phone{
      display: none;
    }
  }
  @media (max-width:1430px) {
    #desk{
      display: none;
    }
    #Phone{
      display: block;
    }
  }

/deep/ .van-slider__button, /deep/ .van-slider__bar ,.btns{
  background-color: $index_color!important;
}

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue